import { Component, Input, Output, EventEmitter } from "@angular/core"
import { HelpersService } from "src/app/services/helpers.service"
import { environment } from "src/environments/environment"
declare var $: any

@Component({
	selector: "app-point-to-point-info",
	templateUrl: "./point-to-point-info.component.html",
	styleUrls: ["./point-to-point-info.component.scss"]
})
export class PointToPointInfoComponent {
	public assets_version = environment.ASSETS_VERSION
	@Input() buildingType: string
	@Output() doCheckBea = new EventEmitter()
	@Output() doGoToP2P = new EventEmitter()

	constructor(public helpersService: HelpersService) {}

	goTpP2P() {
		this.closeModal("p2p-info")
		this.doGoToP2P.emit()
	}

	open(content) {
		$("#" + content).modal("show")
	}

	closeModal(content) {
		$("#" + content).modal("hide")
	}

	checkBea() {
		this.doCheckBea.emit()
		this.closeModal("p2p-info")
	}
}
